<template>
  <div>
    <form v-if="showFilterBox" class="bg-light-2 p-3">
      <div class="form-group m-0">
        <input
          v-model="filteredFacetName"
          type="text"
          class="form-control"
          placeholder="Search"
        />
      </div>
    </form>
    <div class="card-body overflow-list overflow-auto m-0 p-0">
      <ul class="list-group list-group-flush">
        <li
          v-for="facet in filteredFacets"
          :key="facet.value"
          class="list-group-item"
          :class="contentTypeClass(facet)"
        >
          <input
            :id="getId(facet.value)"
            type="checkbox"
            :checked="facet.isSelected"
            :aria-label="facet.name"
            @change="onChange(facet.value)"
          />
          <label
            :class="{ disabled: !facet.count }"
            :for="getId(facet.value)"
            class="m-0 ml-2"
          >
            {{ facet.name }}
            <span v-show="isFacetCountVisible(facet)">({{ facet.count }})</span>
          </label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapGetters } = createNamespacedHelpers('search');

export default {
  name: 'FacetFilters',

  props: {
    /** @type {import('vue').PropOptions<import('./store/state').FacetResponse[]>} */
    facets: {
      type: Array,
      required: true,
    },
    /** @type {import('vue').PropOptions<number>} */
    groupId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      filteredFacetName: '',
    };
  },

  computed: {
    ...mapGetters(['contentTypeTaxonomies']),

    /**
     * @returns {boolean}
     */
    showFilterBox() {
      return this.facets.length > 5;
    },

    /** @returns {boolean} */
    areAnyFacetsSelected() {
      return this.filteredFacets.some((f) => f.isSelected);
    },

    literatureTaxonomy() {
      /** @type {{ name: string, nodeGuid: string }[]} */
      const taxonomies = this.contentTypeTaxonomies;

      return (
        taxonomies.find((t) => t.name === 'literature') || { nodeGuid: '' }
      );
    },

    videoTaxonomy() {
      /** @type {{ name: string, nodeGuid: string }[]} */
      const taxonomies = this.contentTypeTaxonomies;

      return taxonomies.find((t) => t.name === 'video') || { nodeGuid: '' };
    },

    product() {
      /** @type {{ name: string, nodeGuid: string }[]} */
      const taxonomies = this.contentTypeTaxonomies;

      return taxonomies.find((t) => t.name === 'product') || { nodeGuid: '' };
    },

    pressReleaseNews() {
      /** @type {{ name: string, nodeGuid: string }[]} */
      const taxonomies = this.contentTypeTaxonomies;

      return (
        taxonomies.find((t) => t.name === 'pressReleaseNews') || {
          nodeGuid: '',
        }
      );
    },

    /**
     * @returns {import('./store/state').FacetResponse[]}
     */
    filteredFacets() {
      return this.facets.filter((o) =>
        o.name.toLowerCase().includes(this.filteredFacetName.toLowerCase()),
      );
    },
  },

  methods: {
    /**
     * @returns {string}
     */
    getId(facetId) {
      return `taxonomy-${facetId}`;
    },

    /**
     * @param {import('./store/state').FacetResponse} facet
     * @returns {string}
     */
    contentTypeClass(facet) {
      if (facet.id === this.literatureTaxonomy.nodeGuid) {
        return 'lg-deco lg-literature';
      }

      if (facet.id === this.product.nodeGuid) {
        return 'lg-deco lg-product';
      }

      if (facet.id === this.pressReleaseNews.nodeGuid) {
        return 'lg-deco lg-newspr';
      }

      if (facet.id === this.videoTaxonomy.nodeGuid) {
        return 'lg-deco lg-video';
      }

      return '';
    },

    /**
     * @param {import('./store/state').FacetResponse} facet
     * @returns {boolean}
     */
    isFacetCountVisible(facet) {
      return this.areAnyFacetsSelected ? facet.isSelected : true;
    },

    onChange(filterId) {
      this.$emit('change', {
        filterId,
        groupId: this.groupId,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.overflow-list {
  height: 200px;
}
</style>
